import { ExpireType } from '../model/BO/FileBO';
import {
  getDownloadFileUrl,
  getOpenFileUrl,
  LoginFormModel,
  RegisterSendModel,
  registerSkip,
  RegisterValidateModel,
  resendSMSLoginAuthCode,
  sendRegisterCheckRequest,
  sendRegisterCodeRequest,
  smsLogin,
  SMSSendModel,
} from '../api/FileApi';

export const expireMap = new Map([
  [ExpireType.DAY, '24小时'],
  [ExpireType.WEEk, '7天'],
  [ExpireType.MONTH, '1个月'],
  [ExpireType.PERMANAGE, '永久有效'],
]);

export function downloadFile(fileId: string, domainId?: string) {
  getDownloadFileUrl(fileId, domainId)
    .then((fileUrl: any) => {
      window.location.href = fileUrl;
      // const a = document.createElement('a');
      // a.href = fileUrl;
      // document.body.appendChild(a);
      // a.click();
      // a.remove();
    })
    .catch((err) => {
      console.log('下载失败');
    });
}

export async function openPreviewFile(domain: string, shareId: string, domainId?: string) {
  if (domain) {
    getOpenFileUrl(shareId, domainId || '')
      .then((data: any) => {
        window.location.href = data.url;
      })
      .catch(() => {
        console.log('打开失败');
      });
    // const url = `${domain}/api/drive/file/teamwork/open?fileId=${shareId}`;
    // // const url = `${domain}/v1/view/preview?businessCode=wps.preview.drive.share&shareOpenId=${shareId}`;
    // window.open(url);
  }
}

/**
 * 发送短信登录验证码
 *
 * @export
 * @param {SMSSendModel} smsSendModel
 * @returns
 */
export function resendSMSLoginCode(smsSendModel: SMSSendModel) {
  return resendSMSLoginAuthCode(smsSendModel);
}

/**
 * 短信验证登录
 *
 * @export
 * @param {LoginFormModel} loginForm
 * @returns
 */
export function sms2Login(loginForm: LoginFormModel) {
  return smsLogin(loginForm).then((response) => {
    if (response) {
      return response.data;
    }
    return response;
  });
}

// 注册跳过 拿到token
export function registerSkipStep(countryCode: string, mobilePhone: string) {
  return registerSkip(countryCode, mobilePhone).then((data: any) => {
    return data.data;
  });
}

/**
 * 发送注册请求
 * @param registerSendModel
 */
export function registerCodeRequest(registerSendModel: RegisterSendModel) {
  return sendRegisterCodeRequest(registerSendModel).then((data) => {
    if (data) {
      return data.data;
    }
    return null;
  });
}

/**
 * 发送 验证验证码请求
 * @param registerValidateModel
 */
export function registerCheckRequest(registerValidateModel: RegisterValidateModel) {
  return sendRegisterCheckRequest(registerValidateModel);
}
